import { sub } from 'date-fns'
import type { Base_Bus } from '../Base/Base.Bus'
import { Logg_createLogger } from '../Logg/Logg.Logger'
import { Todo_doneReportsPrune } from './Todo.DoneReport'
import { Todo_scheduledInstancesPrune } from './Todo.ScheduledInstance'
import { Todo_sync } from './Todo.sync'

export async function Todo_initialise(bus: Base_Bus) {
    // Handle calling for todo sync on bus
    bus.registerHandler('todo_sync', Todo_sync)

    // Run the deletions now and periodically thereafter
    await doPeriodicPruning()
}

async function doPeriodicPruning() {
    try {
        await doPruning()
    } finally {
        // Run deletions again in 30 seconds
        window.setTimeout(doPeriodicPruning, 30 * 1000)
    }
}

async function doPruning() {
    const deletionThreshold = getTodoDeletionThreshold()
    // Prune old scheduled instances and done reports as time may have passed whilst the device was off
    await Todo_scheduledInstancesPrune(deletionThreshold)
    await Todo_doneReportsPrune(deletionThreshold)
}

const pruningThresholdDurationOverrideKey = 'Pruning_Threshold_Duration'
const defaultDuration: Duration = { days: 14 }
function getTodoDeletionThreshold(): Date {
    let threshold: Date
    try {
        const durationAsString = window.sessionStorage.getItem(pruningThresholdDurationOverrideKey)
        const duration: Duration = JSON.parse(durationAsString)
        if (duration) {
            threshold = sub(new Date(), duration)
            const logger = Logg_createLogger('getTodoDeletionThreshold')
            logger.log(`Using overridden deletion threshold: ${threshold}`)
        }
    } catch {
        // no-op (use default below)
    }

    if (!threshold) {
        threshold = sub(new Date(), defaultDuration)
    }
    return threshold
}

/**
 * Override the time period that needs to pass before scheduled instances and done reports are viable for pruning.
 * The default is 14 days.
 *
 * This is exposed to make it easier to test manually.  The value is only persisted for the browser session.
 */
export function setTodoDeletionThreshold(duration: Duration): void {
    if (duration) {
        const durationAsString = JSON.stringify(duration)
        window.sessionStorage.setItem(pruningThresholdDurationOverrideKey, durationAsString)
    } else {
        window.sessionStorage.removeItem(pruningThresholdDurationOverrideKey)
    }
}
